import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import {
  EntityCardBlueprint,
  EntityContentBlueprint,
} from '@backstage/plugin-catalog-react/alpha';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import { azureAccessApi } from './api';
import { hasAzureAccess } from './components/EntityAzureAccessContent';
import { rootRouteRef } from './routes';

/** "My Azure access" — in the sidebar, for everyone. */
export const myAzureAccessPage = PageBlueprint.make({
  params: {
    path: '/azure-access',
    title: 'My Azure access',
    icon: <VpnKeyIcon />,
    routeRef: rootRouteRef,
    loader: () =>
      import('./components/MyAzureAccessPage').then(m => (
        <m.MyAzureAccessPage />
      )),
  },
});

/**
 * "Azure access" tab on users, groups, systems, resource groups, managed
 * identities and app registrations. The backend shows anyone their own user
 * page; everything else only to the admin groups.
 */
export const entityAzureAccessContent = EntityContentBlueprint.make({
  params: {
    path: 'azure-access',
    title: 'Azure access',
    filter: hasAzureAccess,
    loader: () =>
      import('./components/EntityAzureAccessContent').then(m => (
        <m.EntityAzureAccessContent />
      )),
  },
});

/** "Azure" summary card on system pages. */
export const systemAzureSummaryCard = EntityCardBlueprint.make({
  name: 'system-summary',
  params: {
    type: 'info',
    filter: entity => entity.kind.toLocaleLowerCase('en-US') === 'system',
    loader: () =>
      import('./components/SystemAzureSummaryCard').then(m => (
        <m.SystemAzureSummaryCard />
      )),
  },
});

export const azureAccessPlugin = createFrontendPlugin({
  pluginId: 'azure-access',
  extensions: [
    azureAccessApi,
    myAzureAccessPage,
    entityAzureAccessContent,
    systemAzureSummaryCard,
  ],
  routes: {
    root: rootRouteRef,
  },
});
